// extracted by mini-css-extract-plugin
export default {"innerWrapper":"oy-z","tooltipWrapper":"py-z","icon":"qy-z","tooltip":"ry-z","content":"sy-z"};